export const CIVILBUDGET_LOADING = "CIVILBUDGET_LOADING";
export const CIVILBUDGET_RESET = "CIVILBUDGET_RESET";
export const GET_CIVILBUDGET = "GET_CIVILBUDGET";
export const GET_CIVILBUDGET_SUCCESS = "GET_CIVILBUDGET_SUCCESS";
export const GET_CIVILBUDGET_FAIL = "GET_CIVILBUDGET_FAIL";
export const DELETE_CIVILBUDGET = "DELETE_CIVILBUDGET"
export const DELETE_CIVILBUDGET_SUCCESS = "DELETE_CIVILBUDGET_SUCCESS"
export const DELETE_CIVILBUDGET_FAIL = "DELETE_CIVILBUDGET_FAIL"
export const UPDATE_CIVILBUDGET = "UPDATE_CIVILBUDGET"
export const UPDATE_CIVILBUDGET_SUCCESS = "UPDATE_CIVILBUDGET_SUCCESS"
export const UPDATE_CIVILBUDGET_FAIL = "UPDATE_CIVILBUDGET_FAIL"
export const ADD_NEW_CIVILBUDGET = "ADD_NEW_CIVILBUDGET"
export const ADD_CIVILBUDGET_SUCCESS = "ADD_CIVILBUDGET_SUCCESS"
export const ADD_CIVILBUDGET_FAIL = "ADD_CIVILBUDGET_FAIL"